<div class="unsaved-warning-modal ig-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <mat-icon class="modal-icon">warning</mat-icon>
    <h3 data-testId="title">Continue without saving?</h3>
    <p>
        You have unsaved entries. If you continue these changes will be discarded
    </p>
    <div class="operate default" (click)="discard()">
        Continue
    </div>
    <div class="operate" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/unsaved.warning.modal/unsaved.warning.modal.component.html